import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { data } from "../../Utils/DummyData";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./About.scss";

// About
const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    setAbouts(data)
  }, [])
  return (
    <>
      {/* Heading */}
      <h2 className="head-text">
        A Blend of   <span>Frontend Creativity</span>
        <br />
        & <span>Backend Power</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profiles-item"
            key={about.title + index}
          >
            {/* image */}
            <img src={about.imgUrl} alt={about.title} />
            {/* title */}
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            {/* description */}
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
